import React, { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";
import { Tooltip, IconButton, Zoom } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Brightness4, Brightness7 } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(6),
    right: theme.spacing(6),
    zIndex: theme.zIndex.speedDial,
    [theme.breakpoints.down('sm')]: {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  },
  button: {
    width: 40,
    height: 40,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  icon: {
    fontSize: '1.25rem',
  },
}));

export const ThemeToggle = () => {
  const classes = useStyles();
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div className={classes.root}>
      <Tooltip
        title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        placement="left"
        TransitionComponent={Zoom}
        arrow
      >
        <IconButton
          color="inherit"
          onClick={toggleTheme}
          aria-label="Toggle theme"
          className={classes.button}
        >
          {theme === 'light' ? (
            <Brightness4 className={classes.icon} />
          ) : (
            <Brightness7 className={classes.icon} />
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
};